var map = {
	"./af": "./node_modules/chart.js/node_modules/moment/locale/af.js",
	"./af.js": "./node_modules/chart.js/node_modules/moment/locale/af.js",
	"./ar": "./node_modules/chart.js/node_modules/moment/locale/ar.js",
	"./ar-dz": "./node_modules/chart.js/node_modules/moment/locale/ar-dz.js",
	"./ar-dz.js": "./node_modules/chart.js/node_modules/moment/locale/ar-dz.js",
	"./ar-kw": "./node_modules/chart.js/node_modules/moment/locale/ar-kw.js",
	"./ar-kw.js": "./node_modules/chart.js/node_modules/moment/locale/ar-kw.js",
	"./ar-ly": "./node_modules/chart.js/node_modules/moment/locale/ar-ly.js",
	"./ar-ly.js": "./node_modules/chart.js/node_modules/moment/locale/ar-ly.js",
	"./ar-ma": "./node_modules/chart.js/node_modules/moment/locale/ar-ma.js",
	"./ar-ma.js": "./node_modules/chart.js/node_modules/moment/locale/ar-ma.js",
	"./ar-sa": "./node_modules/chart.js/node_modules/moment/locale/ar-sa.js",
	"./ar-sa.js": "./node_modules/chart.js/node_modules/moment/locale/ar-sa.js",
	"./ar-tn": "./node_modules/chart.js/node_modules/moment/locale/ar-tn.js",
	"./ar-tn.js": "./node_modules/chart.js/node_modules/moment/locale/ar-tn.js",
	"./ar.js": "./node_modules/chart.js/node_modules/moment/locale/ar.js",
	"./az": "./node_modules/chart.js/node_modules/moment/locale/az.js",
	"./az.js": "./node_modules/chart.js/node_modules/moment/locale/az.js",
	"./be": "./node_modules/chart.js/node_modules/moment/locale/be.js",
	"./be.js": "./node_modules/chart.js/node_modules/moment/locale/be.js",
	"./bg": "./node_modules/chart.js/node_modules/moment/locale/bg.js",
	"./bg.js": "./node_modules/chart.js/node_modules/moment/locale/bg.js",
	"./bn": "./node_modules/chart.js/node_modules/moment/locale/bn.js",
	"./bn.js": "./node_modules/chart.js/node_modules/moment/locale/bn.js",
	"./bo": "./node_modules/chart.js/node_modules/moment/locale/bo.js",
	"./bo.js": "./node_modules/chart.js/node_modules/moment/locale/bo.js",
	"./br": "./node_modules/chart.js/node_modules/moment/locale/br.js",
	"./br.js": "./node_modules/chart.js/node_modules/moment/locale/br.js",
	"./bs": "./node_modules/chart.js/node_modules/moment/locale/bs.js",
	"./bs.js": "./node_modules/chart.js/node_modules/moment/locale/bs.js",
	"./ca": "./node_modules/chart.js/node_modules/moment/locale/ca.js",
	"./ca.js": "./node_modules/chart.js/node_modules/moment/locale/ca.js",
	"./cs": "./node_modules/chart.js/node_modules/moment/locale/cs.js",
	"./cs.js": "./node_modules/chart.js/node_modules/moment/locale/cs.js",
	"./cv": "./node_modules/chart.js/node_modules/moment/locale/cv.js",
	"./cv.js": "./node_modules/chart.js/node_modules/moment/locale/cv.js",
	"./cy": "./node_modules/chart.js/node_modules/moment/locale/cy.js",
	"./cy.js": "./node_modules/chart.js/node_modules/moment/locale/cy.js",
	"./da": "./node_modules/chart.js/node_modules/moment/locale/da.js",
	"./da.js": "./node_modules/chart.js/node_modules/moment/locale/da.js",
	"./de": "./node_modules/chart.js/node_modules/moment/locale/de.js",
	"./de-at": "./node_modules/chart.js/node_modules/moment/locale/de-at.js",
	"./de-at.js": "./node_modules/chart.js/node_modules/moment/locale/de-at.js",
	"./de-ch": "./node_modules/chart.js/node_modules/moment/locale/de-ch.js",
	"./de-ch.js": "./node_modules/chart.js/node_modules/moment/locale/de-ch.js",
	"./de.js": "./node_modules/chart.js/node_modules/moment/locale/de.js",
	"./dv": "./node_modules/chart.js/node_modules/moment/locale/dv.js",
	"./dv.js": "./node_modules/chart.js/node_modules/moment/locale/dv.js",
	"./el": "./node_modules/chart.js/node_modules/moment/locale/el.js",
	"./el.js": "./node_modules/chart.js/node_modules/moment/locale/el.js",
	"./en-au": "./node_modules/chart.js/node_modules/moment/locale/en-au.js",
	"./en-au.js": "./node_modules/chart.js/node_modules/moment/locale/en-au.js",
	"./en-ca": "./node_modules/chart.js/node_modules/moment/locale/en-ca.js",
	"./en-ca.js": "./node_modules/chart.js/node_modules/moment/locale/en-ca.js",
	"./en-gb": "./node_modules/chart.js/node_modules/moment/locale/en-gb.js",
	"./en-gb.js": "./node_modules/chart.js/node_modules/moment/locale/en-gb.js",
	"./en-ie": "./node_modules/chart.js/node_modules/moment/locale/en-ie.js",
	"./en-ie.js": "./node_modules/chart.js/node_modules/moment/locale/en-ie.js",
	"./en-nz": "./node_modules/chart.js/node_modules/moment/locale/en-nz.js",
	"./en-nz.js": "./node_modules/chart.js/node_modules/moment/locale/en-nz.js",
	"./eo": "./node_modules/chart.js/node_modules/moment/locale/eo.js",
	"./eo.js": "./node_modules/chart.js/node_modules/moment/locale/eo.js",
	"./es": "./node_modules/chart.js/node_modules/moment/locale/es.js",
	"./es-do": "./node_modules/chart.js/node_modules/moment/locale/es-do.js",
	"./es-do.js": "./node_modules/chart.js/node_modules/moment/locale/es-do.js",
	"./es.js": "./node_modules/chart.js/node_modules/moment/locale/es.js",
	"./et": "./node_modules/chart.js/node_modules/moment/locale/et.js",
	"./et.js": "./node_modules/chart.js/node_modules/moment/locale/et.js",
	"./eu": "./node_modules/chart.js/node_modules/moment/locale/eu.js",
	"./eu.js": "./node_modules/chart.js/node_modules/moment/locale/eu.js",
	"./fa": "./node_modules/chart.js/node_modules/moment/locale/fa.js",
	"./fa.js": "./node_modules/chart.js/node_modules/moment/locale/fa.js",
	"./fi": "./node_modules/chart.js/node_modules/moment/locale/fi.js",
	"./fi.js": "./node_modules/chart.js/node_modules/moment/locale/fi.js",
	"./fo": "./node_modules/chart.js/node_modules/moment/locale/fo.js",
	"./fo.js": "./node_modules/chart.js/node_modules/moment/locale/fo.js",
	"./fr": "./node_modules/chart.js/node_modules/moment/locale/fr.js",
	"./fr-ca": "./node_modules/chart.js/node_modules/moment/locale/fr-ca.js",
	"./fr-ca.js": "./node_modules/chart.js/node_modules/moment/locale/fr-ca.js",
	"./fr-ch": "./node_modules/chart.js/node_modules/moment/locale/fr-ch.js",
	"./fr-ch.js": "./node_modules/chart.js/node_modules/moment/locale/fr-ch.js",
	"./fr.js": "./node_modules/chart.js/node_modules/moment/locale/fr.js",
	"./fy": "./node_modules/chart.js/node_modules/moment/locale/fy.js",
	"./fy.js": "./node_modules/chart.js/node_modules/moment/locale/fy.js",
	"./gd": "./node_modules/chart.js/node_modules/moment/locale/gd.js",
	"./gd.js": "./node_modules/chart.js/node_modules/moment/locale/gd.js",
	"./gl": "./node_modules/chart.js/node_modules/moment/locale/gl.js",
	"./gl.js": "./node_modules/chart.js/node_modules/moment/locale/gl.js",
	"./gom-latn": "./node_modules/chart.js/node_modules/moment/locale/gom-latn.js",
	"./gom-latn.js": "./node_modules/chart.js/node_modules/moment/locale/gom-latn.js",
	"./he": "./node_modules/chart.js/node_modules/moment/locale/he.js",
	"./he.js": "./node_modules/chart.js/node_modules/moment/locale/he.js",
	"./hi": "./node_modules/chart.js/node_modules/moment/locale/hi.js",
	"./hi.js": "./node_modules/chart.js/node_modules/moment/locale/hi.js",
	"./hr": "./node_modules/chart.js/node_modules/moment/locale/hr.js",
	"./hr.js": "./node_modules/chart.js/node_modules/moment/locale/hr.js",
	"./hu": "./node_modules/chart.js/node_modules/moment/locale/hu.js",
	"./hu.js": "./node_modules/chart.js/node_modules/moment/locale/hu.js",
	"./hy-am": "./node_modules/chart.js/node_modules/moment/locale/hy-am.js",
	"./hy-am.js": "./node_modules/chart.js/node_modules/moment/locale/hy-am.js",
	"./id": "./node_modules/chart.js/node_modules/moment/locale/id.js",
	"./id.js": "./node_modules/chart.js/node_modules/moment/locale/id.js",
	"./is": "./node_modules/chart.js/node_modules/moment/locale/is.js",
	"./is.js": "./node_modules/chart.js/node_modules/moment/locale/is.js",
	"./it": "./node_modules/chart.js/node_modules/moment/locale/it.js",
	"./it.js": "./node_modules/chart.js/node_modules/moment/locale/it.js",
	"./ja": "./node_modules/chart.js/node_modules/moment/locale/ja.js",
	"./ja.js": "./node_modules/chart.js/node_modules/moment/locale/ja.js",
	"./jv": "./node_modules/chart.js/node_modules/moment/locale/jv.js",
	"./jv.js": "./node_modules/chart.js/node_modules/moment/locale/jv.js",
	"./ka": "./node_modules/chart.js/node_modules/moment/locale/ka.js",
	"./ka.js": "./node_modules/chart.js/node_modules/moment/locale/ka.js",
	"./kk": "./node_modules/chart.js/node_modules/moment/locale/kk.js",
	"./kk.js": "./node_modules/chart.js/node_modules/moment/locale/kk.js",
	"./km": "./node_modules/chart.js/node_modules/moment/locale/km.js",
	"./km.js": "./node_modules/chart.js/node_modules/moment/locale/km.js",
	"./kn": "./node_modules/chart.js/node_modules/moment/locale/kn.js",
	"./kn.js": "./node_modules/chart.js/node_modules/moment/locale/kn.js",
	"./ko": "./node_modules/chart.js/node_modules/moment/locale/ko.js",
	"./ko.js": "./node_modules/chart.js/node_modules/moment/locale/ko.js",
	"./ky": "./node_modules/chart.js/node_modules/moment/locale/ky.js",
	"./ky.js": "./node_modules/chart.js/node_modules/moment/locale/ky.js",
	"./lb": "./node_modules/chart.js/node_modules/moment/locale/lb.js",
	"./lb.js": "./node_modules/chart.js/node_modules/moment/locale/lb.js",
	"./lo": "./node_modules/chart.js/node_modules/moment/locale/lo.js",
	"./lo.js": "./node_modules/chart.js/node_modules/moment/locale/lo.js",
	"./lt": "./node_modules/chart.js/node_modules/moment/locale/lt.js",
	"./lt.js": "./node_modules/chart.js/node_modules/moment/locale/lt.js",
	"./lv": "./node_modules/chart.js/node_modules/moment/locale/lv.js",
	"./lv.js": "./node_modules/chart.js/node_modules/moment/locale/lv.js",
	"./me": "./node_modules/chart.js/node_modules/moment/locale/me.js",
	"./me.js": "./node_modules/chart.js/node_modules/moment/locale/me.js",
	"./mi": "./node_modules/chart.js/node_modules/moment/locale/mi.js",
	"./mi.js": "./node_modules/chart.js/node_modules/moment/locale/mi.js",
	"./mk": "./node_modules/chart.js/node_modules/moment/locale/mk.js",
	"./mk.js": "./node_modules/chart.js/node_modules/moment/locale/mk.js",
	"./ml": "./node_modules/chart.js/node_modules/moment/locale/ml.js",
	"./ml.js": "./node_modules/chart.js/node_modules/moment/locale/ml.js",
	"./mr": "./node_modules/chart.js/node_modules/moment/locale/mr.js",
	"./mr.js": "./node_modules/chart.js/node_modules/moment/locale/mr.js",
	"./ms": "./node_modules/chart.js/node_modules/moment/locale/ms.js",
	"./ms-my": "./node_modules/chart.js/node_modules/moment/locale/ms-my.js",
	"./ms-my.js": "./node_modules/chart.js/node_modules/moment/locale/ms-my.js",
	"./ms.js": "./node_modules/chart.js/node_modules/moment/locale/ms.js",
	"./my": "./node_modules/chart.js/node_modules/moment/locale/my.js",
	"./my.js": "./node_modules/chart.js/node_modules/moment/locale/my.js",
	"./nb": "./node_modules/chart.js/node_modules/moment/locale/nb.js",
	"./nb.js": "./node_modules/chart.js/node_modules/moment/locale/nb.js",
	"./ne": "./node_modules/chart.js/node_modules/moment/locale/ne.js",
	"./ne.js": "./node_modules/chart.js/node_modules/moment/locale/ne.js",
	"./nl": "./node_modules/chart.js/node_modules/moment/locale/nl.js",
	"./nl-be": "./node_modules/chart.js/node_modules/moment/locale/nl-be.js",
	"./nl-be.js": "./node_modules/chart.js/node_modules/moment/locale/nl-be.js",
	"./nl.js": "./node_modules/chart.js/node_modules/moment/locale/nl.js",
	"./nn": "./node_modules/chart.js/node_modules/moment/locale/nn.js",
	"./nn.js": "./node_modules/chart.js/node_modules/moment/locale/nn.js",
	"./pa-in": "./node_modules/chart.js/node_modules/moment/locale/pa-in.js",
	"./pa-in.js": "./node_modules/chart.js/node_modules/moment/locale/pa-in.js",
	"./pl": "./node_modules/chart.js/node_modules/moment/locale/pl.js",
	"./pl.js": "./node_modules/chart.js/node_modules/moment/locale/pl.js",
	"./pt": "./node_modules/chart.js/node_modules/moment/locale/pt.js",
	"./pt-br": "./node_modules/chart.js/node_modules/moment/locale/pt-br.js",
	"./pt-br.js": "./node_modules/chart.js/node_modules/moment/locale/pt-br.js",
	"./pt.js": "./node_modules/chart.js/node_modules/moment/locale/pt.js",
	"./ro": "./node_modules/chart.js/node_modules/moment/locale/ro.js",
	"./ro.js": "./node_modules/chart.js/node_modules/moment/locale/ro.js",
	"./ru": "./node_modules/chart.js/node_modules/moment/locale/ru.js",
	"./ru.js": "./node_modules/chart.js/node_modules/moment/locale/ru.js",
	"./sd": "./node_modules/chart.js/node_modules/moment/locale/sd.js",
	"./sd.js": "./node_modules/chart.js/node_modules/moment/locale/sd.js",
	"./se": "./node_modules/chart.js/node_modules/moment/locale/se.js",
	"./se.js": "./node_modules/chart.js/node_modules/moment/locale/se.js",
	"./si": "./node_modules/chart.js/node_modules/moment/locale/si.js",
	"./si.js": "./node_modules/chart.js/node_modules/moment/locale/si.js",
	"./sk": "./node_modules/chart.js/node_modules/moment/locale/sk.js",
	"./sk.js": "./node_modules/chart.js/node_modules/moment/locale/sk.js",
	"./sl": "./node_modules/chart.js/node_modules/moment/locale/sl.js",
	"./sl.js": "./node_modules/chart.js/node_modules/moment/locale/sl.js",
	"./sq": "./node_modules/chart.js/node_modules/moment/locale/sq.js",
	"./sq.js": "./node_modules/chart.js/node_modules/moment/locale/sq.js",
	"./sr": "./node_modules/chart.js/node_modules/moment/locale/sr.js",
	"./sr-cyrl": "./node_modules/chart.js/node_modules/moment/locale/sr-cyrl.js",
	"./sr-cyrl.js": "./node_modules/chart.js/node_modules/moment/locale/sr-cyrl.js",
	"./sr.js": "./node_modules/chart.js/node_modules/moment/locale/sr.js",
	"./ss": "./node_modules/chart.js/node_modules/moment/locale/ss.js",
	"./ss.js": "./node_modules/chart.js/node_modules/moment/locale/ss.js",
	"./sv": "./node_modules/chart.js/node_modules/moment/locale/sv.js",
	"./sv.js": "./node_modules/chart.js/node_modules/moment/locale/sv.js",
	"./sw": "./node_modules/chart.js/node_modules/moment/locale/sw.js",
	"./sw.js": "./node_modules/chart.js/node_modules/moment/locale/sw.js",
	"./ta": "./node_modules/chart.js/node_modules/moment/locale/ta.js",
	"./ta.js": "./node_modules/chart.js/node_modules/moment/locale/ta.js",
	"./te": "./node_modules/chart.js/node_modules/moment/locale/te.js",
	"./te.js": "./node_modules/chart.js/node_modules/moment/locale/te.js",
	"./tet": "./node_modules/chart.js/node_modules/moment/locale/tet.js",
	"./tet.js": "./node_modules/chart.js/node_modules/moment/locale/tet.js",
	"./th": "./node_modules/chart.js/node_modules/moment/locale/th.js",
	"./th.js": "./node_modules/chart.js/node_modules/moment/locale/th.js",
	"./tl-ph": "./node_modules/chart.js/node_modules/moment/locale/tl-ph.js",
	"./tl-ph.js": "./node_modules/chart.js/node_modules/moment/locale/tl-ph.js",
	"./tlh": "./node_modules/chart.js/node_modules/moment/locale/tlh.js",
	"./tlh.js": "./node_modules/chart.js/node_modules/moment/locale/tlh.js",
	"./tr": "./node_modules/chart.js/node_modules/moment/locale/tr.js",
	"./tr.js": "./node_modules/chart.js/node_modules/moment/locale/tr.js",
	"./tzl": "./node_modules/chart.js/node_modules/moment/locale/tzl.js",
	"./tzl.js": "./node_modules/chart.js/node_modules/moment/locale/tzl.js",
	"./tzm": "./node_modules/chart.js/node_modules/moment/locale/tzm.js",
	"./tzm-latn": "./node_modules/chart.js/node_modules/moment/locale/tzm-latn.js",
	"./tzm-latn.js": "./node_modules/chart.js/node_modules/moment/locale/tzm-latn.js",
	"./tzm.js": "./node_modules/chart.js/node_modules/moment/locale/tzm.js",
	"./uk": "./node_modules/chart.js/node_modules/moment/locale/uk.js",
	"./uk.js": "./node_modules/chart.js/node_modules/moment/locale/uk.js",
	"./ur": "./node_modules/chart.js/node_modules/moment/locale/ur.js",
	"./ur.js": "./node_modules/chart.js/node_modules/moment/locale/ur.js",
	"./uz": "./node_modules/chart.js/node_modules/moment/locale/uz.js",
	"./uz-latn": "./node_modules/chart.js/node_modules/moment/locale/uz-latn.js",
	"./uz-latn.js": "./node_modules/chart.js/node_modules/moment/locale/uz-latn.js",
	"./uz.js": "./node_modules/chart.js/node_modules/moment/locale/uz.js",
	"./vi": "./node_modules/chart.js/node_modules/moment/locale/vi.js",
	"./vi.js": "./node_modules/chart.js/node_modules/moment/locale/vi.js",
	"./x-pseudo": "./node_modules/chart.js/node_modules/moment/locale/x-pseudo.js",
	"./x-pseudo.js": "./node_modules/chart.js/node_modules/moment/locale/x-pseudo.js",
	"./yo": "./node_modules/chart.js/node_modules/moment/locale/yo.js",
	"./yo.js": "./node_modules/chart.js/node_modules/moment/locale/yo.js",
	"./zh-cn": "./node_modules/chart.js/node_modules/moment/locale/zh-cn.js",
	"./zh-cn.js": "./node_modules/chart.js/node_modules/moment/locale/zh-cn.js",
	"./zh-hk": "./node_modules/chart.js/node_modules/moment/locale/zh-hk.js",
	"./zh-hk.js": "./node_modules/chart.js/node_modules/moment/locale/zh-hk.js",
	"./zh-tw": "./node_modules/chart.js/node_modules/moment/locale/zh-tw.js",
	"./zh-tw.js": "./node_modules/chart.js/node_modules/moment/locale/zh-tw.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4;



/*****************
 ** WEBPACK FOOTER
 ** ./~/chart.js/~/moment/locale ^\.\/.*$
 ** module id = 4
 ** module chunks = 0
 **/